import type { CSSProperties, HTMLAttributes } from "react";

interface ScenarioFlowStepProps extends HTMLAttributes<HTMLDivElement> {
  code?: string;
  title?: string;
  status?: "done" | "pending" | "error" | string;
}

function ScenarioFlowStep({
  code = "HC4000",
  title,
  status = "pending",
  style,
  ...restProps
}: ScenarioFlowStepProps) {
  const color = status === "error" ? "#ff4d4f" : status === "done" ? "#52c41a" : "#d9d9d9";
  const containerStyle: CSSProperties = {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "4px 0",
    ...style,
  };

  return (
    <div {...restProps} style={containerStyle}>
      <span
        style={{
          width: 10,
          height: 10,
          borderRadius: "50%",
          border: `2px solid ${color}`,
          display: "inline-block",
          flex: "0 0 auto",
        }}
      />
      <span>{code || title}</span>
    </div>
  );
}

export default ScenarioFlowStep;
